import { SxProps } from '@mui/material';

export const styledAccordionDetailsHDMSx: SxProps = {
	display: 'block',
	width: '100%',
	minHeight: '100% !important',
};
